/**
 * Created by User on 24/08/2020
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import "path-data-polyfill"
import {ReactComponent as Building} from "../icons/wave2.svg"
import {ReactComponent as BuildingIcon} from "../icons/buildings.svg"
import LoadingDial from "../Components/charts/LoadingDial";
import ErrorDial from "../Components/charts/ErrorDial";

class Playground extends Component {

    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
        this.svgRef = React.createRef();
        this.state = {
            svg: {
                width:900,
                height:900,
                prog: 0.1,
                dir: 1
            }
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    componentDidMount() {


    };

    componentWillUnmount() {
    };

    renderCircle(c, r, v, units, icon, text){
        return <g>
            <circle
                fill={"none"}
                strokeWidth={0.02}
                stroke={"#DAE3ED"}
                r={r}
                cx={c[0]}
                cy={c[1]}
            />
            <text
                fill={"#2F4653"}
                letterSpacing={"-0.1em"}
                fontWeight={470}
                textAnchor={"middle"} fontSize={"0.05"}
                transform={`translate(${c[0]}, ${c[1] - 5*r/6 + 0.05})`} >{v}</text>

            <text
                fill={"#6A9EA6"}
                letterSpacing={"-0.1em"}
                fontWeight={470}
                textAnchor={"middle"} fontSize={"0.03"}
                transform={`translate(${c[0]}, ${c[1] - r/2 + 0.04})`} >{units}</text>
            <g transform={`translate(${c[0]- 0.05} , ${c[1]-0.027}) scale(0.1, 0.1)`}>
                {icon}
            </g>
            <text
                fill={"#2F4653"}
                letterSpacing={"-0.01em"}
                fontWeight={500}
                textAnchor={"middle"} fontSize={"0.02"}
                transform={`translate(${c[0]}, ${c[1] + 19*r/20 - 0.04})`} >WATER</text>

        </g>
    }

    renderCurvedArrow(w, p1, p2, sweep=false) {
        let temp = p1;
        if(!sweep) {
            p1 = p2;
            p2 = temp;
        }
        let r = Math.sqrt((p1[0]-p2[0])**2 + (p1[1]-p2[1])**2)/2;
        let center = [(p1[0] + p2[0])/2, (p1[1] + p2[1])/2]
        let n = 4;
        let l = Math.sqrt((p2[0]-p1[0])**2+(p2[1]-p1[1])**2);
        let d = [(p2[0]- p1[0])/l,  (p2[1] - p1[1])/l];


        let cx1 = center[0] + (sweep ? -1: 1)*1.414*r;
        let cy1 = center[1] + (d[1] > 0 ? -1: 1)*(n-1)*r/n;

        let cx2 = center[0] + (sweep ? -1: 1)*1.414*r;
        let cy2 = center[1] - (d[1] > 0 ? -1: 1)*(n-1)*r/n;

        let o = [((d[1] < 0) ? -1 : 1)*d[1], d[0]];
        let sweep_factor = sweep ? -1 : 1
        return <g>
            <path
                strokeWidth={w}
                stroke={"#DAE3ED"}
                fill={"none"}
                d={sweep ? `
                    M ${p1[0]-w*0.9} ${p1[1]}
                    C ${cx1} ${cy1}, ${cx2} ${cy2}, ${p2[0]} ${p2[1]}
                `:`
                    M ${p1[0]} ${p1[1]}
                    C ${cx1} ${cy1}, ${cx2} ${cy2}, ${p2[0] + w*0.9} ${p2[1]}
                `}
            />

            <polygon
                fill={"#DAE3ED"}
                points={`
                         ${(sweep?p1:p2)[0] + d[0]*w + sweep_factor*o[0]*w},${(sweep?p1:p2)[1] + d[1]*w + o[1]*w}
                         ${p2[0]},${(sweep?p1:p2)[1]}
                         ${(sweep?p1:p2)[0] - d[0]*w + sweep_factor*o[0]*w},${(sweep?p1:p2)[1] - d[1]*w + o[1]*w}
                    `
                }
            />
        </g>
    }

    renderArrow(w, p1, p2, dir=true){
            let temp = p1;
            if(dir) {
                p1 = p2;
                p2 = temp;
            }
            let l = Math.sqrt((p2[0]-p1[0])**2+(p2[1]-p1[1])**2);
            let d = [(p2[0] - p1[0])/l, (p2[1] - p1[1])/l];
            let o = [-d[1], d[0]];
            return <g>
                <path
                    strokeWidth={w}
                    stroke={"#DAE3ED"}
                    d={`
                        M ${p1[0]} ${p1[1]}
                        L ${p2[0] - d[0]*w} ${p2[1] - d[1]*w}
                    `}
                />
                <polygon
                    fill={"#DAE3ED"}
                    points={`
                         ${p2[0] + o[0]*w - d[0]*w},${p2[1] + o[1]*w - d[1]*w}
                         ${p2[0]},${p2[1]}
                         ${p2[0] - o[0]*w - d[0]*w},${p2[1] - o[1]*w - d[1]*w}
                    `}
                />
            </g>
    }

    renderSvg(){
        const C = (x) => Math.cos(x)
        const S = (x) => Math.sin(x)
        return <svg
            shapeRendering="geometricPrecision "
            viewBox={"-0.5 0  2 1"}>

            <text
                fill={"#2F4653"}
                letterSpacing={"-0.02em"}
                fontWeight={600}
                textAnchor={"middle"} fontSize={"0.024"}
                transform={`translate(0.5, ${0.445-0.012})`} >
                URBAN AREA
            </text>
            <text
                fill={"#2F4653"}
                letterSpacing={"-0.02em"}
                fontWeight={600}
                textAnchor={"middle"} fontSize={"0.024"}
                transform={`translate(0.5, ${0.575+0.012})`} >
                WATER CYCLE
            </text>

            <g  transform={"translate(0.44, 0.44) scale(0.12, 0.12)"}>
                <BuildingIcon  />
            </g>
            {[...new Array(8)].map((_,i) => {
                let w = 0;
                let dx = C(Math.PI * 2.0 * i / 8.0 + Math.PI / 8);
                let dy = S(Math.PI * 2.0 * i / 8.0 + Math.PI / 8);
                return <g >
                    {this.renderCircle(
                    [
                        dx * 0.36 + 0.5,
                        dy * 0.36 + 0.5
                    ],
                    0.125,
                    100,
                    "ML",
                    <Building/>,
                    "population"
                )}

                    {this.renderArrow(Math.random()*0.03 + 0.03,
                        [
                            dx * 0.225 + 0.5,
                            dy * 0.225 + 0.5
                        ],
                        [

                            dx * 0.11 + 0.5,
                            dy * 0.11 + 0.5
                        ],
                        i > 3
                    )}
                </g>
            })}
            {
                this.renderCurvedArrow(0.025,

                    [0.97, 0.44],
                    [0.97, 0.56],
                    false
                )
            }
            {
                this.renderCurvedArrow(0.025,

                    [0.03, 0.44],
                    [0.03, 0.56],
                    true
                )
            }
        </svg>
    }

    render() {
        return <div style={{width:"100vmin", height:"100vmin"}}>
            {this.renderSvg()}
        </div>
    }
}


Playground.propTypes = {}


export default Playground;
